var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"logo"},[_c('span',{ref:"txt",staticClass:"ble",class:{moving: _vm.config.moving},style:(_vm.fontstyle),domProps:{"innerHTML":_vm._s(_vm.brText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }